import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { hasProjectPermission } from "@/app/capabilities/api/check-permission";
import { projectCapabilitiesQueryOptions } from "@/app/capabilities/api/get-capabilities";
import { PROJECT } from "@/app/capabilities/permissions";
import { hooksQueryOptions } from "@/app/logic-extensions/api/get-hooks";
import { pluginsQueryOptions } from "@/app/logic-extensions/api/get-plugins";
import { LogicExtensionsSkeleton } from "@/app/logic-extensions/components/logic-extensions-skeleton";
import { PluginConfigPage } from "@/app/logic-extensions/pages/plugin-config-page";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/new"
)({
  component: () => (
    <Suspense fallback={<LogicExtensionsSkeleton />}>
      <PluginConfigPage mode="create" />
    </Suspense>
  ),
  async beforeLoad(ctx) {
    await requireProjectPermission(ctx, PROJECT.plugins.create);
    ctx.context.queryClient.prefetchQuery(
      pluginsQueryOptions({ binding: "project", scope: ctx.params })
    );
    // Prefetch hooks only when the caller can read them — the editor loads hooks
    // conditionally (hooks_read), so an unreadable prefetch would just 403.
    const capabilities = await ctx.context.queryClient.ensureQueryData(
      projectCapabilitiesQueryOptions(ctx.params)
    );
    if (hasProjectPermission(capabilities.authz, PROJECT.hooks.read)) {
      ctx.context.queryClient.prefetchQuery(
        hooksQueryOptions({ binding: "project", scope: ctx.params })
      );
    }
  },
  loader: () => ({
    crumb: "New System",
  }),
});
